<template>
  <v-card flat>
    <v-card-text>
      <div class="caption">{{ $t('user_status') }}</div>
      <div class="mt-1">
        <div
          v-if="value.length > 0"
          :style="{ display: 'flex', alignItems: 'center', margin: '-4px' }"
        >
          <v-chip v-for="item in value" :key="item" color="primary" outline>
            {{ text(item) }}
          </v-chip>
        </div>
        <div v-else class="primary--text">-</div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    text(value) {
      return {
        member: this.$t('member'),
        not_member: this.$t('non_member')
      }[value]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/UserStatus.vue